import React, { CSSProperties, ChangeEvent, useState, useRef } from 'react';
import Avatar, { Size, Status } from 'components/base/Avatar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faCamera } from '@fortawesome/free-solid-svg-icons';
import Button from 'components/base/Button';
import imageIcon from 'assets/img/icons/image-icon.png';
import classNames from 'classnames';


interface ImageUploadProps {
  src: string;
  className?: string;
  onChange?: (image: File | null) => void;
}

const ImageUpload = ({
  src,
  onChange,
  className
}: ImageUploadProps) => {
  const [image, setImage] = useState<File | null>(null);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setImage(e.target.files[0]);
      if (onChange) {
        onChange(e.target.files[0]);
      }
    }
  };


  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleButtonClick = () => {
    // Trigger click event on file input element
    fileInputRef.current?.click();
  };


  return (
    <>
      {!src && (
        <div className="text-600 fw-bold d-flex flex-center flex-column gap-3 fs-9 w-100 h-100">
          <img className="mt-3" src={imageIcon} width={40} alt="" onClick={handleButtonClick} />
          <Button variant="link" className="p-0" onClick={handleButtonClick}>
            Add image
          </Button>
        </div>
      )}
      <div className="justify-content-center align-items-center">
        <input ref={fileInputRef}
          className="d-none"
          id="imageFile"
          type="file"
          accept="image/*"
          onChange={handleChange}
        />

        {src && <img onClick={handleButtonClick} style={{ cursor: 'pointer' }}
          className={classNames(
            className,
            'pe-auto'
          )}
          src={image ? URL.createObjectURL(image) : src} alt="image" />}

      </div>
    </>

  );
};

export default ImageUpload;
